// Exports
export default {
	"checkbox": "checkbox_IH6aI"
};
